import React from "react";
import ReactDOM from "react-dom";
import "./i18n";
import "./assets/scss/base.scss";
import MTCApp from "./App";
//import reportWebVitals from './reportWebVitals';
import SurveyContextProvider from "./store/survey-context";
import Footer from "./components/footer/footer";
import Header from "./components/header/header";
import $ from "jquery";

// Let the document know when the mouse is being used
document.body.addEventListener("mousedown", function () {
  document.body.classList.add("using-mouse");
});

// Re-enable focus styling when Tab is pressed
document.body.addEventListener("keydown", function (event) {
  if (event.keyCode === 9) {
    document.body.classList.remove("using-mouse");
  }
});

$(document).on(
  "focus blur",
  "input[type='radio'],input[type='checkbox']",
  function () {
    const elem = $(this);
    $(elem)
      .blur(function () {
        elem.parent().removeClass("outline");
      })
      .focus(function () {
        if (elem.hasClass("sv_q_radiogroup_other")) {
          elem.parent().prev().addClass("outline");
        } else {
          elem.parent().addClass("outline");
        }
      });
  }
);

ReactDOM.render(
  <React.StrictMode>
    <SurveyContextProvider>
      <div className="apla"></div>
      <div className="app-container page-wrapper">
        <Header />
        <main className="content-wrapper">
          <MTCApp />
        </main>
        <Footer />
      </div>
    </SurveyContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
